module.exports = __webpack_public_path__ + "media/bg-nash-2.0da1d1eb.webm";